// extracted by mini-css-extract-plugin
export var dataCell = "_rq-2";
export var dataRow = "_rq-0";
export var headerRow = "_rq-1";